import { TFunction } from "i18next";

export const processHTMLTranslations = (html: string, t: TFunction): string => {
  if (!html) return "";

  const translationPattern = /\{\{\s*([^}]+)\s*\}\}/g;

  return html.replace(translationPattern, (match: string, key: string) => {
    const trimmedKey = key.trim();

    return t(trimmedKey, trimmedKey);
  });
};
